import { HighlightOff } from "@mui/icons-material"
import AttachEmailIcon from "@mui/icons-material/AttachEmail"
import EditlIcon from "@mui/icons-material/Edit"
import { useMediaQuery, useTheme } from "@mui/material"
import React, { FC } from "react"

import { Drawer } from "src/components/common/drawer"
import { IconButton } from "src/components/common/iconButton"
import { Tabs } from "src/components/common/tabs"
import { BasicLayoutStyleProps } from "src/components/layouts/basic"

import { create } from "src/helpers/bem"
import {
  mergeCoExhibitorInvite,
  useCoExhibitorInvite,
} from "src/states/coExhibitorInvite"

import { TranslationMessages } from "src/translations"

import styles from "./AddCoExhibitorDialog.module.scss"
import { AddCoExhibitorEmailInvite } from "./addCoExhibitorEmailInvite"
import { AddCoExhibitorForm } from "./addCoExhibitorForm"

const bem = create(styles, "AddCoExhibitorDialog")

export type AddCoExhibitorDialogProps = {
  messages: TranslationMessages
  style: BasicLayoutStyleProps
}

export const AddCoExhibitorDialog: FC<AddCoExhibitorDialogProps> = ({
  messages,
  style,
}) => {
  const m = messages.pages.booking.detail.actions.addCoExhibitor
  const { open } = useCoExhibitorInvite()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xl"))

  return (
    <Drawer
      anchor="right"
      open={open}
      style={style}
      title={m.title}
      PaperProps={{
        sx: {
          ...(isMobile && { width: "100%" }),
        },
      }}
      onClose={() =>
        mergeCoExhibitorInvite({
          open: false,
        })
      }
      onOpen={() =>
        mergeCoExhibitorInvite({
          open: true,
        })
      }
    >
      <div className={bem()}>
        <div className={bem("header")}>
          <h2 className={bem("title")}>{m.title}</h2>
          <div className={bem("close")}>
            <IconButton
              color={"primary"}
              icon={HighlightOff}
              onClick={() => mergeCoExhibitorInvite({ open: false })}
            />
          </div>
        </div>
        <p className={bem("description")}>{m.description}</p>
        <Tabs
          id="add-co-exhibitor"
          items={[
            {
              label: m.emailInvite.title,
              icon: <AttachEmailIcon />,
              iconPosition: "start",
              node: <AddCoExhibitorEmailInvite messages={messages} />,
            },
            {
              label: m.selfEntry.title,
              icon: <EditlIcon />,
              iconPosition: "start",
              node: <AddCoExhibitorForm messages={messages} />,
            },
          ]}
        />
      </div>
    </Drawer>
  )
}
